import OUTLANDER_2025 from '../data/model/outlander-2025/fr'
import OUTLANDER_2026 from '../data/model/outlander-2026/fr'
import ECLIPSE_CROSS_2026 from '../data/model/eclipse-cross-2026/fr'
import RVR_2026 from '../data/model/rvr-2026/fr'

const FR = {
  ...OUTLANDER_2025,
  ...OUTLANDER_2026,
  ...ECLIPSE_CROSS_2026,
  ...RVR_2026,
  'virtual.tour.card.interior.title': "Explorer l'intérieur",
  'virtual.tour.card.interior.cta': 'Faire la visite virtuelle',
  'virtual.tour.card.exterior.title': "Explorer l'extérieur",
  'virtual.tour.card.exterior.cta': 'Faire la visite virtuelle',

  'tourController.interior': 'Intérieur',
  'tourController.exterior': 'Extérieur',

  'blueprint.soundSystem.question': 'Quelle option de système audio aimeriez-vous explorer?',
  'blueprint.soundSystem.yamahaUltimate': 'Yamaha Ultimate',
  'blueprint.soundSystem.yamahaPremium': 'Yamaha Premium',
  'blueprint.soundSystem.includedIn': 'Inclus dans :',
  'blueprint.soundSystem.includedInUltimate': 'GT, GT Premium',
  'blueprint.soundSystem.includedInPremium': 'ES, SE, LE, et SEL',
  'blueprint.soundSystem.hotspot-1.label': 'Haut-parleur de milieu de gamme',
  'blueprint.soundSystem.hotspot-1.message': 'Haut-parleur de milieu de gamme',
  'blueprint.soundSystem.hotspot-2.label': 'Tweeters',
  'blueprint.soundSystem.hotspot-2.message': 'Tweeters',
  'blueprint.soundSystem.hotspot-3.label': 'Woofers',
  'blueprint.soundSystem.hotspot-3.message': 'Woofers',
  'blueprint.soundSystem.hotspot-4.label': 'Subwoofer',
  'blueprint.soundSystem.hotspot-4.message': 'Subwoofer',

  'blueprint.safety.question': 'Quel SRS aimeriez-vous explorer?',
  'blueprint.safety.includedIn': 'Inclus dans:',
  'blueprint.safety.allTrims': 'Toutes les versions',

  'launcher.expand': 'Développer',
  'chatWrapper.collapse': 'Réduire',
  'chatWrapper.AICanMakeMistakes': "L'assistant intelligent IA peut faire des erreurs.",
  'chatWrapper.checkImportantInfo': 'Vérifiez les informations importantes.',
  'chatWrapper.privacyPolicy': 'Politique de confidentialité.',
  'chatWrapper.privacyPolicyLink': 'https://www.mitsubishi-motors.ca/fr/juridiques/confidentialite',

  'hotspot.soundSystem': 'Système audio',
  'hotspot.allWheelControl': 'Contrôle intégral des quatre roues motrices',
  'hotspot.safetyFeatures': 'Caractéristiques de sécurité',
  'hotspot.mitsubishiConnect': 'Mitsubishi Connect',
  'hotspot.warranty': 'Garantie',
  'hotspot.SAWC': 'S-AWC',
  'hotspot.cargoSpace': 'Espace de chargement',
}

export default FR
